export const AssignmentActionTypes = {

  //get plan
  FETCH_ASSIGNMENT_START: "FETCH_ASSIGNMENT_START",
  FETCH_ASSIGNMENT_SUCCESS: "FETCH_ASSIGNMENT_SUCCESS",
  FETCH_ASSIGNMENT_FAILURE: "FETCH_ASSIGNMENT_FAILURE",
  RESET_ASSIGNMENT_STATE: "RESET_ASSIGNMENT_STATE",
  //get assignment detail by ID
  FETCH_ASSIGNMENT_DETAIL_START: "FETCH_ASSIGNMENT_DETAIL_START",
  FETCH_ASSIGNMENT_DETAIL_SUCCESS: "FETCH_ASSIGNMENT_DETAIL_SUCCESS",
  FETCH_ASSIGNMENT_DETAIL_RESULT_SUCCESS: "FETCH_ASSIGNMENT_DETAIL_RESULT_SUCCESS",
  FETCH_ASSIGNMENT_DETAIL_FAILURE: "FETCH_ASSIGNMENT_DETAIL_FAILURE",
  SET_ASSIGNMENT_COUNTER: "SET_ASSIGNMENT_COUNTER",
  //get assignment result by ID
  FETCH_ASSIGNMENT_RESULT_START: "FETCH_ASSIGNMENT_RESULT_START",
  FETCH_ASSIGNMENT_RESULT_SUCCESS: "FETCH_ASSIGNMENT_RESULT_SUCCESS",
  FETCH_ASSIGNMENT_RESULT_WARNING: "FETCH_ASSIGNMENT_RESULT_WARNING",
  FETCH_ASSIGNMENT_RESULT_FAILURE: "FETCH_ASSIGNMENT_RESULT_FAILURE",
  //get assignment result detail by ID
  FETCH_ASSIGNMENT_RESULT_DETAIL_START: "FETCH_ASSIGNMENT_RESULT_DETAIL_START",
  FETCH_ASSIGNMENT_RESULT_DETAIL_SUCCESS: "FETCH_ASSIGNMENT_RESULT_DETAIL_SUCCESS",
  FETCH_ASSIGNMENT_RESULT_DETAIL_FAILURE: "FETCH_ASSIGNMENT_RESULT_DETAIL_FAILURE",
  //get assignment answer by ID
  FETCH_ASSIGNMENT_ANSWER_START: "FETCH_ASSIGNMENT_ANSWER_START",
  FETCH_ASSIGNMENT_ANSWER_SUCCESS: "FETCH_ASSIGNMENT_ANSWER_SUCCESS",
  FETCH_ASSIGNMENT_ANSWER_FAILURE: "FETCH_ASSIGNMENT_ANSWER_FAILURE",
  //post assignment 
  FETCH_POST_ASSIGNMENT_START: "FETCH_POST_ASSIGNMENT_START",
  FETCH_POST_ASSIGNMENT_SUCCESS: "FETCH_POST_ASSIGNMENT_SUCCESS",
  FETCH_POST_ASSIGNMENT_FAILURE: "FETCH_POST_ASSIGNMENT_FAILURE",
  //get Results
  FETCH_RESULTS_START: "FETCH_ASSIGNMENT_RESULTS_START",
  FETCH_RESULTS_SUCCESS: "FETCH_ASSIGNMENT_RESULTS_SUCCESS",
  FETCH_RESULTS_FAILURE: "FETCH_ASSIGNMENT_RESULTS_FAILURE",
  RESET_RESULTS_LOADMORE: "RESET_RESULTS_LOADMORE",
  RESET_RESULTS_STATE: "RESET_ASSIGNMENT_RESULTS_STATE",
  //Options
  SET_SHOW_NEXT_QUESTION: "SET_ASSIGNMENT_SHOW_NEXT_QUESTION",
  //Answer
  SET_ANSWER: "SET_ASSIGNMENT_ANSWER",

  //Reset Error
  RESET_ERROR: "RESET_ASSIGNMENT_ERROR",
  //Current Page
  SET_CURRENT_PAGE: "SET_ASSIGNMENT_CURRENT_PAGE",
  //Exam Type
  SET_ASSIGNMENT_MODE: "SET_ASSIGNMENT_MODE",

  //reset Plan Offset
  RESET_PLAN_OFFSET: "RESET_ASSIGNMENT_PLAN_OFFSET",

  //reset Result Offset
  RESET_RESULT_OFFSET: "RESET_ASSIGNMENT_RESULT_OFFSET",
  SET_RESULT_OFFSET: "SET_RESULT_OFFSET",
  //get Points
  FETCH_STUNDENT_POINTS_START: "FETCH_STUNDENT_POINTS_START",
  FETCH_STUNDENT_POINTS_SUCCESS: "FETCH_STUNDENT_POINTS_SUCCESS",
  FETCH_STUNDENT_POINTS_FAILURE: "FETCH_STUNDENT_POINTS_FAILURE",

};
